
import {
  Vue,
  Component,
  Mixins,
  Watch,
} from 'vue-property-decorator';
import { Pagination, Tooltip } from 'element-ui';
import { ITrialForm } from '@/types/trial.d';
import { IBTNCONF } from '@/types/base.d';
import api from '@/api/trial';
import bModal from './components/bModal.vue';
import pageMixin from '../../../mixins/pageMixin';

@Component({
  components: {
    Pagination,
    bModal,
    Tooltip,
  },
})
export default class ManageView extends Mixins(pageMixin) {
  private actionBtns: Array<IBTNCONF> = [{
    title: '新增',
    name: '/course/trial:add',
    icon: 'plus',
    callback: this.handleAddTrial,
    log: {
      name: '试听管理 - 新增',
      component: 'trial/manage/bModal',
    },
  }];

  private cards: any = [];

  private loading: boolean = true;

  private visible: boolean = false;

  private title: string = '添加试听课';

  private form: ITrialForm = {
    title: '',
    type: '',
    knowledges: [],
    content: '',
  }

  mounted() {
    this.page.pageSize = 10;
  }

  /**
   * @author liangyongmou
   * @desc 获取试听课列表
   */
  getData() {
    this.loading = true;
    api.getTrialList(this.page).then((res: any) => {
      this.total = res.totalElements;
      this.cards = res.content;
      this.loading = false;
    });
  }

  /**
   * @author liangyongmou
   * @desc 添加试听课
   */
  handleAddTrial() {
    this.title = '添加试听课';
    this.visible = true;
  }

  /**
   * @author liangyongmou
   * @desc 编辑试听课
   */
  handleEditTrial(item: ITrialForm) {
    this.form = {
      title: item.title,
      type: item.type,
      knowledges: item.knowledges,
      content: item.content,
      pid: item.pid,
      editorType: item.editorType,
    };
    this.title = '编辑试听课';
    this.visible = true;
  }

  /**
   * @author liangyongmou
   * @desc 删除试听课
   * @param { pid } 试听课pid
   */
  handleRemoveTrial(pid: string) {
    this.confirm('你确定要删除该试听课吗?', {
      title: '警告',
      loading: true,
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      iconType: 'warning',
    }).then((close: Function) => {
      api.removeTrial({ id: pid }).then(() => {
        this.getData();
        close();
        this.$log({
          title: '试听课管理 - 删除 - 确定',
          component: 'trial/manage/bModal',
        });
      }).catch(() => close());
    }).catch(() => this.$log({
      title: '试听课管理 - 删除 - 取消',
      component: 'trial/manage/bModal',
    }));
  }

  @Watch('page', { immediate: false, deep: true })
  handlePageChange() {
    this.getData();
  }
}
